// extracted by mini-css-extract-plugin
export default {"layout":"AdminLayout_layout__-mlFx","main":"AdminLayout_main__ZB3Di","collapsed":"AdminLayout_collapsed__ZLv65","content":"AdminLayout_content__TVEtZ"};